import { db } from "./db";
import type { OutboxKind, OutboxRecord } from "./types";

export async function enqueue(kind: OutboxKind, payload: unknown): Promise<number> {
  const id = await db.outbox.add({
    kind,
    payload,
    ts: Date.now(),
    status: "pending",
    retries: 0,
  });
  return id as number;
}

export async function peekPending(limit = 50): Promise<OutboxRecord[]> {
  return db.outbox.where("status").equals("pending").limit(limit).toArray();
}

export async function markInFlight(id: number): Promise<void> {
  await db.outbox.update(id, { status: "in_flight" });
}

export async function ack(id: number): Promise<void> {
  await db.outbox.delete(id);
}

export async function fail(id: number, error: string): Promise<void> {
  const row = await db.outbox.get(id);
  if (!row) return;
  await db.outbox.update(id, {
    status: "pending",
    retries: row.retries + 1,
    lastError: error,
  });
}

export async function clear(): Promise<void> {
  await db.outbox.clear();
}

export async function size(): Promise<number> {
  return db.outbox.count();
}
